import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { navigationItemShape } from './propTypes';
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';

function MainMenu(props, ref) {
  const {
    desktop,
    locales,
    onClick,
    pageUrls,
    sx,
    siteConfig,
  } = props;
  let { items } = props;

  items = flatFilter(
    'items',
    (item) => item.path !== '/' && item.props?.hidden !== 'all' && item.visibility !== 'none',
    items,
  );
  const desktopItems = flatFilter(
    'items',
    (item) => item.props?.hidden !== 'desktop' && item.visibility !== 'mobile',
    items,
  );
  const mobileItems = flatFilter(
    'items',
    (item) => item.props?.hidden !== 'mobile' && item.visibility !== 'desktop',
    items,
  );

  const handleItemClick = (e) => onClick?.(e);

  return desktop ? (
    <DesktopMenu
      ref={ref}
      items={desktopItems}
      onClick={handleItemClick}
      sx={sx}
    />
  ) : (
    <MobileMenu
      ref={ref}
      items={mobileItems}
      locales={locales}
      onClick={handleItemClick}
      pageUrls={pageUrls}
      siteConfig={siteConfig}
      sx={sx}
    />
  );
}

const MainMenuWithRef = forwardRef(MainMenu);

MainMenuWithRef.propTypes = {
  desktop: PropTypes.bool,
  mobile: PropTypes.bool,
  items: PropTypes.arrayOf(navigationItemShape),
  // Events
  onClick: PropTypes.func,
  siteConfig: PropTypes.object,
};

export default MainMenuWithRef;

function flatFilter(nestedProp, predicate, arr) {
  return arr.filter(predicate).map((o) => {
    if (o[nestedProp]) {
      return {
        ...o,
        [nestedProp]: flatFilter(nestedProp, predicate, o[nestedProp]),
      };
    }
    return o;
  });
}
